<template>
  <div class="range-item-box">
    <div>
      <div class="content">
        <span v-if="title !== '年息范围' && title.indexOf('年化利率') == -1" class="value number-font-family">{{ value }}</span>
        <span v-else-if="value.indexOf('~') !== -1" class="value">{{ value.slice(0, -1) }}</span>
        <!-- 不高于不低于的情况 -->
        <template v-else>
          <span class="unit">{{ value.slice(0, 3) }}</span>
          <span class="value number-font-family">{{ value.slice(3, -1) }}</span>
        </template>
        <span class="unit">{{ unit }}</span>
      </div>
      <span class="title">
        {{ title }}
        <el-tooltip v-if="tip" class="item" effect="dark" :content="tip" placement="top">
          <i  class="el-icon-warning"></i>
        </el-tooltip>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: [Number, String],
      default: ''
    },
    unit: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.range-item-box {
  @include displayCenter;
  flex-direction: column;
  flex-grow: 0;
  min-width: 180px; // 保证行间对齐

  .content {
    display: flex;
    align-items: flex-end;
    color: rgba(255, 76, 0, 1);
    margin-bottom: 10px;

    .value {
      @include text-36-bold;
      font-size: 26px;
      display: inline-block;
      line-height: 27px;
    }

    .unit {
      font-size: 16px;
      display: inline-block;
    }
  }

  .title {
    @include text-20-400;
    color: rgba(153, 153, 153, 1);
    font-size: 16px;
  }
}
</style>
